<template>
  <div>
  <v-container
    class="fill-height login-background"
    :style="{
      backgroundImage: `url('/images/${imagelogin}')`,
    }"
    fluid
    v-if="!loading"
  >
    <v-row justify="center" no-gutters>
      <!-- login box -->
      <v-col class="pa-2" cols="12" sm="7" md="5" lg="3">
        <v-form @submit.prevent="submit" ref="formLogin">
          <v-card rounded="xl" class="login-card">
              <v-card-title class="login-card-header">
                <v-row align="stretch" no-gutters>
                  <v-col cols="3" class="d-flex align-center logos">
                    <v-img
                      v-if="!isSercondi"
                      :src="logos.i"
                      alt="logo"
                      max-width="48px"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col cols="6" class="px-2 d-flex justify-center align-center">
                    <template v-if="logomid">
                      <v-img
                        :src="logos.c"
                        alt="logo"
                        max-width="100px"
                        max-height="48px"
                        contain
                      ></v-img>
                    </template>
                    <template v-else>
                      <div class="app-logo text-center">FACTURA MYPE</div>
                    </template>
                  </v-col>
                  <v-col cols="3" class="d-flex align-center justify-end logos">
                    <v-img
                      v-if="!isSercondi"
                      :src="logos.d"
                      alt="logo"
                      max-width="80px"
                      contain
                    ></v-img>
                  </v-col>
                  <v-col
                    class="text-h4 text-center font-weight-bold mb-4"
                    cols="12"
                  >
                    Inicio de Sesión
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
              <v-row align="stretch" no-gutters>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    autocomplete="new-password"
                    v-model="form.username"
                    label="Usuario"
                    filled
                    :rules="[rules.required]"
                  ></v-text-field>

                  <password-field  
                    outlined
                    dense
                    autocomplete="new-password"
                    v-model="form.password"
                    label="Contraseña"
                    ref="pass"
                    filled
                    :rules="[rules.required]">
                  </password-field>

                  <v-autocomplete
                    outlined
                    dense
                    v-model="form.business"
                    :items="businessList"
                    item-text="BusinessName"
                    item-value="ID_Business"
                    @change="onItemSelected"
                    label="Seleccione su negocio"
                    filled
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="9">
                  <v-checkbox
                    label="Recordarme"
                    v-model="form.rememberme"
                  ></v-checkbox>
                </v-col>
                <v-col cols="3">
                  <v-img
                    :src="BusinessLogoPath"
                    alt="logo"
                    max-width="200px"
                    position="right center"
                    contain
                  ></v-img>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">Iniciar Sesión</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <!-- rebembered users box -->
      <v-col
        v-if="loginData.length > 0"
        class="pa-2"
        cols="12"
        sm="4"
        md="3"
        lg="2"
      >
        <v-card class="py-3" color="white" rounded="lg">
          <v-list
            id="box-scroll"
            class="overflow-y-auto"
            style="max-height: 390px"
            dense
          >
            <v-list-item
              v-for="(user, index) in loginData"
              @click="loginRemember(user)"
              :key="index"
            >
              <v-list-item-avatar>
                <v-img
                  :src="
                    user.profileImage2
                      ? user.profileImage2
                      : user.businesstype === 'bloodtestlaboratory'
                      ? '/images/profile/innovaLab_Icon_WhiteFrame.png'
                      : user.businesstype === 'veterinary'
                      ? '/images/profile/innovaVet_Icon_WhiteFrame.png'
                      : user.businesstype === 'accounting_and_bill'
                      ? '/images/profile/innovaBill_Icon_WhiteFrame.png'
                      : '/images/profile/InnovaMed_WhiteFrime.png'
                  "
                  contain
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  >{{ user.firstName }} {{ user.lastName }}</v-list-item-title
                >
                <v-list-item-subtitle class="text-center">
                  <v-btn @click="removeCookie(user)" color="error" text small
                    >Dejar de recordar</v-btn
                  >
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <!-- loading overlay -->
    

    <!-- alert component -->
    <alert
      v-model="alert.show"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      btn-cancel-text="Aceptar"
    ></alert>
  </v-container>
  <block v-if="loading"></block>
  </div>
</template>

<script>
import {
  setTokenMasterCookie,
  setBackendURLCookie,
  setIDKeyMasterCookie,
} from "@/helpers/token";
import {
  VUE_APP_ENV,
  VUE_APP_CARSEM_ID_KEYMASTER1,
  VUE_APP_CARSEM_ID_KEYMASTER2,
  VUE_APP_CARSEM_ID_KEYMASTER3,
} from "../config";
import PasswordField from '../components/PasswordField.vue';
import { redirectToMaster } from '@/helpers/token'
// import utilities from "../api/utilities";
// import axios from '../api/axios'

function isMypeEnabled() {
  return false
}

export default {
  components: { PasswordField },
  name: "Login",
  data: () => ({
    valid: false,
    url: null,
    loading: true,
    imagelogin: "login/bill.png",
    businessShow: null,
    logomid: "",
    form: {
      username: "",
      password: "",
      business: "",
      rememberme: false,
    },
    alert: {
      show: false,
      type: "info",
      title: "",
      message: "",
    },
    rules: {
      required: (value) => !!value || "Este campo es obligatorio",
    },
    businessList: [],
    loginData: [],
    savedCredentials: null,
    BusinessLogoPath: null,
    partner_belongs_to: "",
    isCarsem: false,
    Sercordi: [
      'd6d47d6edfc3812b5c68c16a07d51d8b',
      'f33722a12f5e692b30374bbcf86011db',
      '9ede19c286c95b4aefd2462de691183a',
      '032b4fb2a80bacb6d7b912cd2fa6c005',
      'ecbfba3a7cf5697352a16eecb423adbf',
      '52e4d5b54ff5a95a878deca1491bdd36',
      '2107b29ad7f6c567a5ea72523a108fd0',
      'f6daed50da50e4b0b0d6a514924b4ba8',
      '7dbaa6c5d1580847e0a49fdf483368fb',
      '5bec960eb509c9cb6db215bdc9998cd8',
      '679f296532b2e6338c68854d96282b42',
      '4dc71fd7bb69e474c1c666b079b22b86',
      '1597f7f48934a388677abbbb51e347c9',
      '200d353d8408ede686f8bd71f448da50',
      '689510125c294fa0c2b02d6200cceb7f',
      'ff76ef9fc8848bb8738301248c7239fb',
      'd76ca00b6f45acf9815bc10e1d9b7652',
      'bc6bb5650ed8c31cf987f8bdc005ea00',
      '4e763a092e7859318c95b8332265e42c',
      '23447fc82b92ec56b3eccf77594fa91f',
      'c6f9d1531a792da1124b0a2413c25365',
      'f9c64db2974a9972d733339bee6ad4c0',
      '8e1154138455cd976e1facf35c04a766'
    ], //Agregar keymaster para logos de SERCONDI
    logos:{
      i: '/images/logo/muchiwa.png',
      c: '',
      d:'/images/logo/InnovaLogo.png',
    }
  }),
  computed: {
    selectedBusiness() {
      const selected = this.businessList.filter((item) => item.ID_Business === this.form.business)
      return selected.length ? selected?.[0] : {}
    },
    checktype() {
      return this.form.business;
    },
    isSercondi(){
      return (this.partner_belongs_to ?? "").toString().replace(" ", '').toLowerCase() === 'sercondi' 
      //|| this.Sercordi.includes(this.selectedBusiness?.ID_KeyMaster ? this.selectedBusiness?.ID_KeyMaster : this.selectedBusiness?.sys_business_business_keys?.[0]?.ID_KeyMaster)
    },
    isSelectedBusinessMype() {
      return isMypeEnabled(this.selectedBusiness?.IsMype ?? this.selectedBusiness?.ismype);
    },
  },
  async mounted() {
    if (VUE_APP_ENV == 1) {
      this.devCookies()
    }

    //window.location.href = `${VUE_APP_MASTER_FRONTEND_URL}?redirect=1`;
    if (VUE_APP_ENV == 2) {
      if (!this.getCookie("tokenMaster")) {
        if (this.$route.query.token != undefined) {
          const token = decodeURIComponent(this.$route.query.token);
          const { data } = await this.$API.token.useToken(token);

          if (data.success) {
            setTokenMasterCookie(token);
            this.$router.push("/login");
            window.location.reload();
          } else {
           redirectToMaster();
          }
        } else {
         redirectToMaster();
        }
      }
      const { data } = await this.$API.token.verifyToken(
        this.getCookie("tokenMaster")
      );
      setIDKeyMasterCookie(data);

      setBackendURLCookie(data);
    }

    // if (VUE_APP_ENV == 2) {
    //   try {
    //     for (const element of JSON.parse(this.getCookie("ID_KeyMaster"))) {
    //       const {
    //         data: { content: backendurlfromdb },
    //       } = await this.$API.token.verifyBackendURL({ idkeymaster: element });

    //       if (
    //         this.getCookie("BackendUrl") &&
    //         this.getCookie("BackendUrl").length > 0
    //         // && backendurlfromdb != this.getCookie("BackendUrl")
    //       ) {
    //        redirectToMaster();
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    await this.getBusinessList();
    if (
      this.getCookie("details") != undefined &&
      this.getCookie("details").trim().length > 0
    ) {
      this.cookieLogin(JSON.parse(this.getCookie("details")));
    }
  },
  watch: {},
  methods: {
    devCookies:function (){
      console.log('DevCookies');
      
        const date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        const expires = date.toUTCString();
        const baseDomain = window.location.hostname;

        document.cookie = `frontendUrl=http://localhost:8080;expires=${expires};domain=${baseDomain};path=/;`;
        document.cookie = `BackendUrl=http://localhost:8000/api/;expires=${expires};domain=${baseDomain};path=/;`;
        //document.cookie = `tokenMaster=test-token-12345;expires=${expires};domain=${baseDomain};path=/;`;
      
    },
    onItemSelected() {
      try {
        let data;

        this.businessList.forEach((element) => {
          if (element.ID_Business == this.form.business) {
            data = element;
          }
        });

        this.partner_belongs_to = data?.partner_belongs_to || "";
        
        const keyMastersArray = JSON.parse(this.getCookie("ID_KeyMaster"));
        const specialKeyMasters =
          keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER1) ||
          keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER2) ||
          keyMastersArray.includes(VUE_APP_CARSEM_ID_KEYMASTER3);
          
        if (specialKeyMasters) {
          if (this.form.business === 33) {
            this.imagelogin = "login/loginbackcarsem.jpg";
            this.logomid = "/images/InnovaBanners/InnovaCarsem.jpg";
            this.isCarsem = true;
          }
          if (this.form.business === 44) {
            this.imagelogin = "login/loginbackresauto.jpg";
            this.logomid = "/images/InnovaBanners/InnovaResauto.png";
            this.isCarsem = true;
          }
        } else if (data.BusinessType == "bloodtestlaboratory") {
          this.BusinessLogoPath = data.BusinessLogoPath;
          this.imagelogin = "login/loginbacklab.jpg";
          this.logomid = "/images/InnovaBanners/InnovaLab.png";
          this.isCarsem = false;
        } else if (data.BusinessType == "veterinary") {
          this.BusinessLogoPath = data.BusinessLogoPath;
          this.imagelogin = "login/loginbackvet.jpg";
          this.logomid = "/images/InnovaBanners/InnovaVet.png";
          this.isCarsem = false;
        } else if (data.BusinessType == "accounting_and_bill") {
          this.BusinessLogoPath = data.BusinessLogoPath;
          this.imagelogin = "login/bill.png";
          this.logomid = "/images/InnovaBanners/InnovaBill.png";
          this.isCarsem = false;
          if(this.isSercondi) {
            this.logomid = "/images/InnovaBanners/NewInnovaSercondi.jpg"
          }
        } else if (data.BusinessType == "medicalclinic") {
          this.BusinessLogoPath = data.BusinessLogoPath;
          this.imagelogin = "login/loginbackmed.png";
          this.logomid = "/images/InnovaBanners/InnovaMed.png";
          this.isCarsem = false;
        }
        this.logos.c = this.logomid;
      } catch (error) {
        console.log(error);
      }
    },
    showAlert(type, title, message) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
    },
    submit() {
      this.loading = true;
      if (!this.$refs.formLogin.validate()) {
        this.showAlert(
          "error",
          "Error",
          "Tienes que completar todos los campos para iniciar sesión"
        );
        this.loading = false;
        return;
      }

      let bussnesdataSelected = this.businessList.filter(
        (item) => item.ID_Business == this.form.business
      );
      this.$API.auth
        .login(this.form, bussnesdataSelected)
        .then((res) => {
          this.alert = false;
          this.cookieManagement(this.form.rememberme, res.data);

          this.$router.push({ path: "/" });
          this.$API.general.systemParam();
        })
        .catch((error) => {
          if (!error.success) {
            this.showAlert(
              "warning",
              "Credenciales incorrectas",
              "El usuario o contraseña es incorrecto"
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getBusinessList() {
      this.loading = true;
      try {
        const response = await this.$API.business.businessList({
          ID_KeyMaster: this.getCookie("ID_KeyMaster"),
          ID_Desktop: this.getCookie("ID_Desktop"),
        });

        if (this.businessShow) {
          for (var i = 0; i <= response.length; i++) {
            if (response[i]["BusinessName"] == this.businessShow) {
              this.businessList.push(response[i]);
              this.form.business = this.businessList[0].ID_Business;
            }
          }
        } else {
          this.businessList = response;
        }

        let data = this.businessList[0].BusinessType;
        this.BusinessLogoPath = this.businessList[0].BusinessLogoPath;
        this.form.business = this.businessList[0].ID_Business;

        if (data == "bloodtestlaboratory") {
          this.imagelogin = "login/loginbacklab.jpg";
          this.logomid = "/images/InnovaBanners/InnovaLab.png";
        } else if (data == "veterinary") {
          this.imagelogin = "login/loginbackvet.jpg";
          this.logomid = "/images/InnovaBanners/InnovaVet.png";
        } else if (data == "accounting_and_bill") {
          this.imagelogin = "login/bill.png";
          this.logomid = "/images/InnovaBanners/InnovaBill.png";
        } else if (data == "medicalclinic") {
          this.imagelogin = "login/loginbackmed.png";
          this.logomid = "/images/InnovaBanners/InnovaMed.png";
        }
        this.onItemSelected();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    cookieManagement(rememberme, data) {
      if (rememberme == true) {
        this.pushManager(data);
        var myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);
        document.cookie =
          "details =" +
          JSON.stringify(this.loginData) +
          ";expires=" +
          myDate +
          ";domain=" +
          window.location.hostname +
          ";path=/";
      }
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    cookieLogin(login) {
      if (login) this.loginData = login;
    },
    pushManager(data) {
      if (this.loginData.length > 0) {
        let valite = false;
        this.loginData.forEach((item) => {
          if (item.id == data.id) {
            valite = true;
          }
        });
        if (!valite) {
          this.loginData.push(data);
        }
      } else {
        this.loginData.push(data);
      }
    },
    loginRemember(user) {
      this.form.username = user.username;
      this.businessList.forEach((element) => {
        if (element.ID_Business == user.businessid) {
          this.form.business = element.ID_Business;
          this.onItemSelected();
        }
      });
      this.$refs.pass.focus();
    },
    removeCookie(user) {
      let array = this.loginData.filter((item) => item.id != user.id);
      this.loginData = array;
      var myDate = new Date();
      myDate.setMonth(myDate.getMonth() + 12);
      document.cookie =
        "details =" +
        JSON.stringify(this.loginData) +
        ";expires=" +
        myDate +
        ";domain=" +
        window.location.hostname +
        ";path=/";
    },
  },
};
</script>

<style scoped>
  .app-logo{
    font-weight: bold;
    color: white;
    text-align: center;
  }
  .login-card {
    backdrop-filter: blur(12px);
    background: white !important;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0,0,0,0.25);
  }
  .login-card-header {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin-bottom: 10px;
    padding: 16px;
    color: rgba(0, 0, 0, 0.6);
  }
  .login-card-header-mype {
    background-color: #004aad;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin-bottom: 24px;
    padding: 16px;
    color: #fff;
  }
  .login-background {
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 100vh;
    width: 100vw;
  }

  .login-background::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
  }

  .login-background > * {
    position: relative;
    z-index: 1;
  }
</style>
